import { useQuery } from "@tanstack/react-query";
import { adminAPI } from "@/lib/api";

interface AnalyticsData {
  totalUsers: number;
  activeUsers: number;
  completionRate: number;
  avgProgress: number;
  growthRate: number;
  popularStrengths: Array<{
    name: string;
    nameAr: string;
    domain: string;
    userCount: number;
    avgRank: number;
  }>;
}

export const useAdminAnalytics = () => {
  return useQuery<AnalyticsData>({
    queryKey: ['adminAnalytics'],
    queryFn: async () => {
      const response = await adminAPI.getAnalytics();
      if (!response.success) {
        throw new Error(response.message || 'Failed to fetch analytics');
      }
      return response.data;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
  });
};
